<template>
  <div class="appointment-card">
    <div class="header-container">
      <div class="left-container">
        <img :src="iconImg" alt="" class="icon" v-if="false">
        <el-input class="strategy-name" v-model="data.custom_strategy_name" v-if="!data.disabled" :maxlength="20"></el-input>
        <span v-else class="strategy-name" :title="data.custom_strategy_name">{{ data.custom_strategy_name }}</span>
      </div>
      <div class="right-container" v-if="false">
        <el-popover
          trigger="click"
          v-if="data.disabled"
          popper-class="appointment-card-popover"
          placement="bottom-start"
          show-arrow="false"
          @show="isBtnBoxShow = true"
          @hide="isBtnBoxShow = false"
        >
          <template #reference>
            <el-icon class="more-icon" :class="{'selected': isBtnBoxShow}"><MoreFilled /></el-icon>
          </template>
          <div class="porper-content">
            <el-button class="edit" @click="edit" :disabled="editButtonDisabled">{{ $str.getKey('策略控制/编辑') }}</el-button>
            <el-button class="edit" @click="edit">{{ $str.getKey('策略控制/编辑') }}</el-button>
            <el-button class="delete" @click="remove">{{ $str.getKey('策略控制/删除') }}</el-button>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="mian-container" :class="{ 'disabled-state': data.disabled }">
      <el-form  :disabled="data.disabled" :model="data" :rules="rules" ref="formRef" label-position="left">
        <el-form-item :label="$str.getKey('策略控制/生效日期')" prop="execution_time">
          <el-date-picker v-model="data.execution_time" :disabled-date="disabledDate" class="my-input" :disabled="data.disabled"></el-date-picker>
        </el-form-item>
        <el-form-item :label="$str.getKey('策略控制/充放电模式')" prop="week_plan">
          <el-select v-model="data.week_plan" class="my-input" :disabled="data.disabled">
            <el-option :label="$str.getKey('策略控制/无休')" value="0"></el-option>
            <el-option :label="$str.getKey('策略控制/单休')" value="1"></el-option>
            <el-option :label="$str.getKey('策略控制/双休')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$str.getKey('策略控制/需量')" prop="demand">
          <el-input-number controls-position="right" v-model="data.demand" class="my-input has-unit" :max="999999" :min="0" @blur="checkInputDemand" :disabled="data.disabled || (props.autoDemand && !data.id)"></el-input-number>
          <span class="unit-text">kW</span>
        </el-form-item>
        <el-form-item :label="$str.getKey('策略控制/虚拟电厂调度')" prop="third_ctl_en" class="switch-item">
          <div class="switch-container">
            <el-switch v-model="data.third_ctl_en" active-value="1" inactive-value="0" :disabled="data.disabled"></el-switch>
            <span class="switch-text">{{data.third_ctl_en === '1' ? $str.getKey('策略控制/允许') : $str.getKey('策略控制/禁止')}}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer-container">
        <el-button round class="edit" v-if="data.disabled" @click="edit" :disabled="editButtonDisabled">{{ $str.getKey('策略控制/编辑') }}</el-button>
        <!-- <el-button round class="btn edit" v-if="data.disabled" @click="edit">{{ $str.getKey('策略控制/编辑') }}</el-button> -->
        <el-button round class="btn delete" v-if="data.disabled" @click="remove">{{ $str.getKey('策略控制/删除') }}</el-button>
        <el-button round class="btn cancel" v-if="!data.disabled" @click="cancelEdit">{{ $str.getKey('策略控制/取消') }}</el-button>
        <el-button round class="btn save" v-if="!data.disabled" @click="save">{{ $str.getKey('策略控制/保存') }}</el-button>
        <el-button round class="btn run" @click="openRunStrategy(data.disabled)">{{ $str.getKey('策略控制/运行策略') }}</el-button>
    </div>


    <!-- ====== 抽屉：运行策略 ======================================================================================================================== -->
    <el-drawer v-model="drawerVisible" direction="rtl" append-to-body destroy-on-close :title="$str.getKey('策略控制/预约运行策略管理')" size="60%" class="cus-drawer-20241114-143756 cus-drawer cus-drawer-2 appointment-run-strategy-drawer"
      @open="resetDrawerScroll" @opened="resetDrawerScroll" @close="resetDrawerScroll" @closed="resetDrawerScroll">
      <strategy-editor ref="sEditRef" v-model:isEdit="runStateIsEdit"
        :currentELinkData="toEditerData" :hideEditButton="data.disabled"></strategy-editor>
      <template #footer>
        <el-button @click="onRunStrategyCancel" v-if="runStateIsEdit">{{ $str.getKey('策略控制/取消') }}</el-button>
        <el-button @click="drawerVisible = false" v-else>{{ $str.getKey('全局/关闭') }}</el-button>
        <el-button type="primary" @click="onRunStrategyConfirm" v-if="runStateIsEdit">{{ $str.getKey('策略控制/保存') }}</el-button>
      </template>
    </el-drawer>
  </div>
</template>

<script setup>
import { Delete, Edit, Operation, CloseBold, Select } from "@element-plus/icons-vue"
import { computed, inject, nextTick, reactive, ref, watch } from "vue"
import dayjs from "dayjs"
import * as strategyApi from '../api.js';
import { cur_elk, Appointment, toBinStr, compareStrategy, cusConfirm } from "../utils.js";
import StrategyEditor from "./StrategyEditor.vue"
import useUserStore from '@/store/modules/user'


const $str = window.$str;
const props = defineProps(['strategyData', 'appointmentList', 'iconImg', 'autoDemand'])

const userStore = useUserStore()

const data = reactive(Appointment())

const sEditRef = ref(null)
const drawerVisible = ref(false)
const runStateIsEdit = ref(false)
const currentELinkData = inject(cur_elk)
const isBtnBoxShow = ref(false)

const editButtonDisabled = computed(()=> {
  return (new Date(data.execution_time) < Date.now()) && data.id
})

const formRef = ref(null)
const rules = reactive({
  execution_time: [
    { required: true, message: $str.getKey('策略控制/生效日期不能为空'), trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        const times = new Set()
        const names = new Map()
        for (const item of props.appointmentList) {
          if (item !== props.strategyData) {
            times.add(item.execution_time)
            names.set(item.execution_time, item.custom_strategy_name)
          }
        }
        const day = dayjs(value).format('YYYY-MM-DD')
        if (times.has(day)) {
          const sName = names.get(day)
          callback(new Error($str.getKey('策略控制/生效日期与') + sName + $str.getKey('策略控制/重复')))
        } else {
          callback()
        }
      },
      trigger: "blur"
    },
  ],
  // demand: [
  //   { required: true, message: $str.getKey('策略控制/需量不能为空'), trigger: "blur" },
  //   {
  //     validator: (rule, value, callback) => {
  //       if (value <= 0) {
  //         callback(new Error($str.getKey('策略控制/需量必须大于0')))
  //       } else {
  //         callback()
  //       }
  //     },
  //     trigger: "blur"
  //   },

  // ],
  week_plan: [{ required: true, message: $str.getKey('策略控制/充放电模式不能为空'), trigger: "blur" }]
})

const StatusInfo = {
  1: '未执行',
  2: '已执行',
  3: '执行中',
}
const StatusTag = {
  1: 'warning',
  2: 'info',
  3: 'success',
}

const status = computed(() => {
  // props.strategyData.execution_time > 
  const executeTime = dayjs(props.strategyData.execution_time)
  const nowDay = dayjs()
  if (executeTime > nowDay) {
    return 1
  } else if (executeTime < nowDay) {
    return 2
  } else {
    return 3
  }
})


function disabledDate(date) {
  return date < Date.now()
}

watch(props.strategyData, (value) => {
  Object.assign(data, value)
  // 如果是新增计划且autoDemand为true，设置需量默认值为1
  if (props.autoDemand && !value.id) {
    data.demand = 1
  }
}, {
  immediate: true
})

const emit = defineEmits(['remove', 'cancelEdit', 'save'])


const toEditerData = reactive({
  powerLimit: currentELinkData.value.powerLimit,
  strategys_work: computed(() => {
    return data.strategys_work
  }),
  strategys_rest: computed(() => {
    return data.strategys_rest
  })
})

function openRunStrategy(disabled) {
  drawerVisible.value = true

  // 抽屉带 destroy-on-close，内容是本次打开才挂载的，
  // 首个 nextTick 拿不到 ref 时再等一帧，避免策略数据没回填
  const initEditor = (retry = true) => {
    if (!sEditRef.value) {
      if (retry) nextTick(() => initEditor(false))
      return
    }
    sEditRef.value.updateLocalStrategy()
    if (disabled) {
      sEditRef.value.exitEdit()
    } else {
      sEditRef.value.startEdit()
    }
    resetDrawerScroll() // 每次打开时滚动条回到顶部
  }
  nextTick(() => initEditor())
}

/** 抽屉不销毁自身容器，滚动位置会沿用上次，这里把内部所有滚动容器归零 */
function resetDrawerScroll() {
  const reset = () => {
    // 每张预约卡片都有一个同类抽屉，未打开的归零也无副作用，索引全部处理
    document.querySelectorAll('.appointment-run-strategy-drawer').forEach(drawer => {
      drawer.scrollTop = 0
      drawer.querySelectorAll('*').forEach(el => {
        if (el.scrollTop || el.scrollLeft) {
          el.scrollTop = 0
          el.scrollLeft = 0
        }
      })
    })
    sEditRef.value?.scrollToTop?.()
  }
  // 抽屉有展开动画，内容高度逐帧变化，动画期间多归零几次
  nextTick(reset)
  requestAnimationFrame(() => {
    reset()
    requestAnimationFrame(reset)
  })
  setTimeout(reset, 120)
  setTimeout(reset, 360)
}

function onRunStrategyCancel() {
  sEditRef.value.exitEdit()
}

function onRunStrategyConfirm() {
  const strategys = sEditRef.value.getStrategys(false)
  const valid = sEditRef.value.checkValidate()
  if (!valid) {
    return
  }
  data.strategys_work = strategys.work
  data.strategys_rest = strategys.rest


  if (strategys.work.length == 0) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/工作日策略不能为空')
    });
    return
  }

  if (strategys.rest.length == 0) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/休息日策略不能为空')
    });
    return
  }


  sEditRef.value.exitEdit()


  save()

}


function edit() {
  data.disabled = false
}

function cancelEdit() {
  data.disabled = true
  emit('cancelEdit', data.id)
}





// 比较数据是否发生变化
function hasChanged(newData, oldData) {

  const compareKeys = ['custom_strategy_name', 'execution_time', 'demand', 'week_plan', 'strategys_rest', 'strategys_work', 'third_ctl_en']

  for (const key of compareKeys) {
    let newValue = newData[key]
    let oldValue = oldData[key]

    // 值为数组时比较策略
    if (Array.isArray(newValue)) {
      if (!compareStrategy(newValue, oldValue)) {
        return true
      }
      continue
    }

    if (key === 'execution_time') {
      newValue = dayjs(newValue).format('YYYY-MM-DD')
      oldValue = dayjs(oldValue).format('YYYY-MM-DD')
    }


    if (newValue != oldValue) {
      return true
    }
  }

  return false
}


function save() {
  formRef.value.validate((valid) => {
    if (!valid) {
      return
    }

    const postData = Object.assign({}, data, {
      station_id: currentELinkData.value.station_id,
      station_name: currentELinkData.value.station_name,
      third_ctl_en: data.third_ctl_en,
      execution_time: dayjs(data.execution_time).format('YYYY-MM-DD'),
      opt_user: userStore.name,
      elink_id: currentELinkData.value.elink_id,
      elink_name: currentELinkData.value?.elink_name,
      strategy_mode:'0'    // 策略模式配置写死策略模式，暂不支持变压器保护模式   2024-08-30
    })

    if (postData.demand <= 0) {
      window.dispatchNotify({
        type: 'info',
        message: $str.getKey('策略控制/需量不能为0')
      });
      return
    }


    if (postData.strategys_work.length == 0 || postData.strategys_rest.length == 0) {
      window.dispatchNotify({
        type: 'info',
        message: $str.getKey('策略控制/请设置运行策略')
      });
      return
    }

    const hasChange = hasChanged(postData, props.strategyData)


    // 有主键ID时，修改
    if (data.id != null) {
      if (hasChange) {
        strategyApi.putCustomStrategy(postData).then(r => {
          if (r.code == 200) {
            window.dispatchNotify({
              type: 'success',
              message: $str.getKey('策略控制/修改成功!')
            });
            data.disabled = true
            emit('save')
          }
        })
      } else {
        data.disabled = true
      }
    }
    // 无主键ID时，新增
    else {
      strategyApi.postCustomStrategy(postData).then(r => {
        if (r.code == 200) {
          window.dispatchNotify({
            type: 'success',
            message: $str.getKey('策略控制/新增成功!')
          });
          data.disabled = true
          emit('save')
        }
      })
    }

  })
}

function remove() {
  cusConfirm($str.getKey('策略控制/确定要删除吗?')).then(ok => {
    if (ok) {
      emit('remove', data)
    }
  })
}


/** 检查输入的需量值，小数自动取整 */
function checkInputDemand() {
  const v = data.demand;
  if (/^\d+\.\d+$/.test(v)) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/需量不允许设置小数，已自动为您取整')
    });
    data.demand = Math.round(v);
  }
}
  

</script>

<style lang="scss" scoped>
.appointment-card {
  padding:20px; // 增大内边距
  box-sizing: border-box;
  min-width: 320px;
  min-height: 300px;
  height: 100% !important;
  background: #FFFFFF;
  color: #2E2E2E;
  border-radius: 20px;
  box-shadow: 0 2px 8px 0 #00000011;
  letter-spacing: 2px;
  display: flex;
  flex-direction: column;
  .header-container {
    height: 40px;
    background: #EFF4FBB2;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // 字体样式
    font-family: PingFang-SC, PingFang-SC;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    // line-height: 60px;
    // text-align: center;
    font-style: normal;
    .left-container {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 10px;
      .icon {
        height: 31px;
        width: 31px;
      }
      .el-input {
        // height: 36px !important;
        // background: #2e3648;
        width: 100% !important;
        border-radius: 6px;
        font-size: 14px;
        
        ::v-deep .el-input__wrapper {
          box-shadow: none;
        }
      }
      .strategy-name{
        // width: 200px;
        width: 100%;
        border-width: 0;
        padding: 4 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: bold;
        color: #000000;
      }
    }
    .right-container {
      ::v-deep .porper-content {
        width: 100%;
        height: 100%;
        // background: red;
        background-color: #FFFFFF !important;
        display: flex;
        flex-direction: column;
      }
      .more-icon {
        height: 31px;
        width: 31px;
        transform: rotate(90deg);
        cursor: pointer;
        color: #505B74;
        &:hover {
          // background: #2E3648;
          background: #151920AA;
        }
        &.selected {
          // background: #2E3648;
          background: #151920AA;
        }

      }
    }
  }
  .mian-container {
    margin: 18px 0 0 0;
    $form-input-height: 32px;
    $form-input-width: 95%;

    .el-form-item {
      margin-bottom: 0px;
      &:not(:last-child) {
        margin-bottom: 18px;
      }

      align-items: center;
      
      &.switch-item {
        .switch-container {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
          
          .switch-text {
            white-space: nowrap;
            font-size: 14px;
            color: #2E2E2E;
            min-width: 40px;
          }
        }
      }
      
      .unit-text {
        margin-left: 10px;
        white-space: nowrap;
        font-size: 14px;
        color: #2E2E2E;
      }
      
      ::v-deep .my-input {
        width: $form-input-width;
        height: $form-input-height;
        border-radius: 12px !important;
        &.has-unit {
          width: calc($form-input-width - 40px);
        }
        .el-input__wrapper, .el-select__wrapper {
          height: $form-input-height !important;
          // box-shadow: none;
          border-radius: 12px;
        }

        &.el-input.is-disabled .el-input__inner, .el-input__inner {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: normal;
          font-size: 14px;
          color: #2E2E2E;
          -webkit-text-fill-color:  #2E2E2E;
          text-align: left;
          font-style: normal;
        }

        .el-input-number__decrease, .el-input-number__increase {
          height: 50%;
          background: transparent;
        }
      }
    }

    &.disabled-state {
        ::v-deep .el-input__inner {
          color: #2E2E2E99 !important;
          -webkit-text-fill-color:  #2E2E2E99 !important;
        }
    }
  }
  .footer-container {
    height: 48px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 10px;
    margin-top: 18px;
    .btn {
      // width: 110px;
      height: 28px;
      margin-left: 0;
      font-size: 14px;
      font-weight: 500;
      &.run {
        color: #fff;
        background: #3A68FF;
        &:hover {
          border: 1px solid #687084;
        }
      }
      &.cancel {
        background: #68708411;
        border: 1px solid #687084;
        &:hover {
          background: #687084AA;
          color: #fff;
        }
      }
      &.save {
        color: #7588FF;
        background: #7588FF22;
        border: 1px solid #7588FF;
        &:hover {
          background: #7588FFAA;
          color: #fff;
        }
      }

    }
  }
}

.appointment-card {
  .header-container {
    font-size: 12px !important;
  }
  ::v-deep .el-form-item__label {
    font-size: 12px !important;
    width: 120px !important;
  }
  
  .mian-container {
    $form-input-width: 70%;
    
    ::v-deep .my-input {
      width: $form-input-width;
    }
  }
}





</style>

<style lang="scss">
.appointment-card-popover {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none;
  padding: 0;
  margin-top: -16px;
  margin-left: -16px;

  .el-popper__arrow {
    visibility: hidden;
    height: 0;
  }
  
  .porper-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .el-button {
      margin: 0;
      width: 101px;
      height: 41px;
      color: #99A4BE;
      border-radius: 3px;

      font-family: PingFang-SC, PingFang-SC;
      font-weight: 500;
      font-size: 16px;
      text-align: center;
      font-style: normal;

      &.edit {
        color: #5974F9;
        // background: #7D89A6;
        box-shadow: inset 0px 0px 16px 0px #7987A7;
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #5F6981;
        &:hover {
          filter: brightness(1.4);
        }
      }

      &.delete {
        background: #3C455A;
        border: 1px solid #5F6981;
        &:hover {
          filter: brightness(1.4);
        }
      }

    }
  }

}


.cus-drawer-20241114-143756.el-drawer {
  width: 80vw !important;
  max-width: 1920px !important;
  border-radius: 30px 0 0 30px !important;
  height: 100% !important;
  max-height: 100vh !important;
  margin: 0 !important;
  background-color: #fff !important;
  background: url('@/assets/images/station-monitor/detail-dialog/detail-bg.svg') no-repeat center center;
  background-size: cover;

  .el-drawer__title {
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 20px;
    padding-left: 26px;
  }
  .el-drawer__close {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    top: 16px;
    right: 24px;
    &:hover {
      background: #e2e4e788;
    }
  }


  &.appointment-drawer {
    .el-alert--info.is-light {
      background: transparent;
    }

    .appointment-wrapper {
      background: #F6FBFF;
      padding: 10px 10px 30px 10px;
      border-radius: 30px;

      .cards-container {
        margin: 16px 26px;
        display: grid;
        grid-auto-flow: row dense;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px 24px;

        .card {
          height: 350px;
          border-radius: 6px;
        }

        .add-card {
          background: #EFF4FBB2;
          height: 350px;
          border-radius: 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 10px;

          .add-img {
            width: 95px;
            height: 95px;
            border-radius: 50%;
            background-color: #E6EFFC;
            background-image: url('@/assets/images/strategy/add.svg');
            background-repeat: no-repeat;
            background-position: center;
          }

          .add-text {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            text-align: center;
          }

          &:hover {
            .add-img {
              background-color: #c0d3d299;
            }
            cursor: pointer;
          }
        }
      }
    }
  }

  .communication-mode-container {
    padding: 0 20px;

    .mode-selection {
      background: #1F2536;
      border-radius: 8px;
      padding: 20px;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #2E2E2E;
        margin-bottom: 20px;
      }

      .mode-options {
        margin-bottom: 20px;

        .el-radio {
          margin-right: 20px;
          margin-bottom: 10px;
          color: #D0D0D0;
        }

        .el-radio__input.is-checked+.el-radio__label {
          color: #409EFF;
        }
      }

      .mode-description {
        background: #2E3648;
        border-radius: 8px;
        padding: 16px;

        .subtitle {
          font-size: 14px;
          font-weight: bold;
          color: #2E2E2E;
          margin-bottom: 10px;
        }

        .desc-text {
          font-size: 13px;
          color: #97A0B7;
          line-height: 1.6;

          .sub-item {
            margin-top: 10px;

            .sub-item-title {
              font-weight: bold;
              color: #D0D0D0;
              margin-bottom: 4px;
            }

            .sub-item-desc {
              padding-left: 15px;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }
}
</style>